import { cn } from "@/utils";
import type { ReactNode } from "react";

type PageSectionProps = {
  /** id do título da section, para `aria-labelledby`. */
  labelledBy?: string;
  className?: string;
  children: ReactNode;
};

/**
 * Faixa de conteúdo da LP com o mesmo alinhamento do `Header`: padding lateral
 * por fora (`px-4 sm:px-6 lg:px-12`) e `max-w-6xl` por dentro. Com o padding
 * dentro do `max-w-6xl`, o conteúdo começava 32px à direita do logo em 1280px.
 */
export const PageSection = ({
  labelledBy,
  className,
  children,
}: PageSectionProps) => (
  <section aria-labelledby={labelledBy} className="px-4 sm:px-6 lg:px-12">
    <div className={cn("mx-auto max-w-6xl", className)}>{children}</div>
  </section>
);
